import store from '../../redux/store'
import { EDIT_SECRET_GENERALES, EDIT_SECRET_RESET } from '../../redux/redux-const'
import APIInvoke from '../../utils/APIInvoke';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';


const getState = () => {
    return store.getState().pages.editSecret
}

const merge = (type, param) => {
    store.dispatch({
        type,
        payload: {
            ...getState(),
            ...param
        }
    })
}

export const init = async (project, secret) => {
    const state = getState()
    let responseSecret = null

    if (secret !== "_new") {
        responseSecret = (await (await APIInvoke.invokeGET(`/projects/${project}/secrets/${secret}`)).json()).body

        merge(EDIT_SECRET_GENERALES, {
            ...state,
            new: false,
            id: responseSecret.id,
            key: responseSecret.key,
            value: responseSecret.value,
            description: responseSecret.description
        })
    }
}

export const reset = () => {
    store.dispatch({ type: EDIT_SECRET_RESET })
}

export const updateGenerales = (action) => {
    const name = action.target.name
    const type = action.target.type
    let value = action.target.value


    if (type === "checkbox") {
        value = action.target.checked
    }
    merge(EDIT_SECRET_GENERALES, { [name]: value })
}

export const save = async (e, project, navigate) => {
    e.preventDefault()
    
    const state = getState()

    const request = {
        key: state.key,
        value: state.value,
        description: state.description
    }

    const response = state.id
        ? await (await APIInvoke.invokePUT(`/projects/${project}/secrets/${state.key}`, request)).json()
        : await (await APIInvoke.invokePOST(`/projects/${project}/secrets`, request)).json()
    if (response.ok) {
        merge(EDIT_SECRET_GENERALES, {
            new: false,
            id: response.body.id
        })
        toast.success(response.message)
        navigate(`/projects/${project}/secrets`)
    } else {
        toast.error(response.message)
    }
}